import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { getDateAsObject } from "../../core/et3-date";
import { TKhattabatAdminsRemunerations } from "../../TypesNEW";

export const apiCallGetKhattabasRemunerations = async ({
  remunerationCycleFrom,
  remunerationCycleTo
}: {
  remunerationCycleFrom: Date;
  remunerationCycleTo: Date;
}): Promise<{
  data: TKhattabatAdminsRemunerations;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TKhattabatAdminsRemunerations>(
    `khattabat/getKhattabatsRemunerations`,
    {
      remunerationCycleFromObject: getDateAsObject(remunerationCycleFrom),
      remunerationCycleToObject: getDateAsObject(remunerationCycleTo)
    }
  );
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
